module.exports = __webpack_public_path__ + "img/open.68cfd530.svg";